import type { AppState } from '../../types';

const LEGACY_KEYS: Record<string, string> = {
  team1BidsAndActuals: 'team1BidsAndMade',
  team2BidsAndActuals: 'team2BidsAndMade',
  autoGeneratedActuals: 'autoGeneratedMade',
  p1Actual: 'p1Made',
  p2Actual: 'p2Made',
};

/** Dealer ids stored as strings, e.g. `team1BidsAndActuals.p1Bid`. */
const LEGACY_DEALER_ID = /^team([12])BidsAndActuals\.(p[12]Bid)$/;

/**
 * Renames legacy field keys. String values are only rewritten when the whole
 * value is a dealer id, so a player name like "p1Actual" is left alone.
 */
function migrateValue(value: unknown): unknown {
  if (Array.isArray(value)) {
    return value.map(migrateValue);
  }
  if (value !== null && typeof value === 'object') {
    const next: Record<string, unknown> = {};
    for (const [key, child] of Object.entries(value as Record<string, unknown>)) {
      next[LEGACY_KEYS[key] ?? key] = migrateValue(child);
    }
    return next;
  }
  if (typeof value === 'string') {
    return value.replace(LEGACY_DEALER_ID, 'team$1BidsAndMade.$2');
  }
  return value;
}

export function migrateStoredValue<T>(key: string, value: T): T {
  if (
    key === 'currentRound' ||
    key === 'roundHistory' ||
    key === 'firstDealerOrder'
  ) {
    return migrateValue(value) as T;
  }
  return value;
}

export function migrateAppState(state: AppState): AppState {
  return migrateValue(state) as AppState;
}
